import { env } from '@/config/env'

export const resolveImageUrl = (
  url: string | undefined | null
): string | undefined => {
  if (!url) return undefined

  if (url.startsWith('http')) {
    return url
  }

  // Remove leading slash if present to avoid double slashes
  const path = url.startsWith('/') ? url : `/${url}`
  return `${env.apiUrl}${path}`
}
